<template>
    <div class="folder" @click.stop="onFolderClick(folder)">
        <router-link :to='"/messages/" + folder.id' tabindex="-1" v-if="list_type === 'router'" v-context-menu="{action: onContextMenu, data: folder}">
            <span class="menu-icon">
                <i :class="folder.icon"></i>
            </span>
            <span class="menu-title">
              {{folder.name}}
              <small>{{Language.say('folders.search.root_folder')}}{{folder.path}}</small>
            </span>
            <span v-if="folder.unread" class="counter">{{folder.unread}}</span>
        </router-link>
        <div v-else>
            <span class="menu-icon">
                <i :class="folder.icon"></i>
            </span>
            <span class="menu-title">
              {{folder.name}}
              <small>{{Language.say('folders.search.root_folder')}}{{folder.path}}</small>
            </span>
        </div>
    </div>
</template>

<script setup>
  import {defineProps, defineEmits} from 'vue';
  import Language                   from '@/js/Shared/Language/Language';

  const emit = defineEmits([
    'folderContextMenu', 'folderSelect', 'folderUnselect',
  ])

  const props = defineProps({
    folders_selection_collection : {
      required: true,
    },

    list_type : {
      default : 'router'
    },

    selection_box : {
      default: null,
    },

    folder : {
      required: true,
    }
  })

  const onToggleCheckSelect = (folder) => {
    if (props.folders_selection_collection.exists(folder.id)) {
      props.folders_selection_collection.delete(folder.id);
      emit('folderUnselect', folder);
      return;
    }

    props.folders_selection_collection.add(folder);
    emit('folderSelect', folder);
  }

  const onToggleRadioSelect = (folder) => {
    if (props.folders_selection_collection.exists(folder.id)) {
      props.folders_selection_collection.delete(folder.id);
      emit('folderUnselect', folder);
      return;
    }

    props.folders_selection_collection.unique(folder);
    emit('folderSelect', folder);
  }

  const onFolderClick = (folder) => {
    if (props.selection_box === 'radio') {
      return onToggleRadioSelect(folder);
    }

    if (props.selection_box === 'check') {
      return onToggleCheckSelect(folder);
    }
  }

  const onContextMenu = (folder) => {
    emit('folderContextMenu', folder);
  }
</script>